import styled from '@emotion/styled'
import { ITheme } from 'utils/type'

interface IStyledProps {
  theme: ITheme
}

export const PopupTitleDiv = styled.div`
  label: PopupTitleDiv;
  font-size: 32px;
  text-align: center;
  margin-bottom: 12px;
`

export const PopupBlockDiv = styled.div`
  label: PopupBlockDiv;
  background-color: #f7f7f7;
  margin: 2px;
  box-sizing: border-box;
  padding: 6px;
  width: 100%;
`
export const PopupBlockTitleDiv = styled.div`
  label: PopupBlockTitleDiv;
  text-transform: uppercase;
  font-size: 19px;
  line-height: 28px;
  font-weight: 600;
`

export const PopupBlockSubtext = styled.div`
  label: PopupBlockSubtext;
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 6px;
`

export const PopupBlockBulletListDiv = styled.div`
  label: PopupBlockBulletListDiv;
  font-size: 12px;
  line-height: 21px;
  margin-left: -21px;
`
